module.exports = __webpack_public_path__ + "img/1960.6de14fd9.png";